import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import FhirLoader from '../../../../FhirLoader'
import { OrganizationAffiliationTable } from '@teschglobal/tg-fhir-react-components'
import type { OrganizationAffiliation } from '@teschglobal/tg-fhir-react-components/dist/types'

type OrganizationAffiliationListProps = {
  organizationAffiliations: ProviderResponse<OrganizationAffiliation>
  clickViewDataLink: (organizationAffiliation: OrganizationAffiliation) => void
  isFetching: boolean
  isSuccess: boolean
  totalPages: number
  currentPage: number
  handleChangePage: (page: number) => void
}

const OrganizationAffiliationList: FC<OrganizationAffiliationListProps> = ({
  organizationAffiliations,
  clickViewDataLink,
  isFetching,
  totalPages,
  currentPage,
  handleChangePage,
}) => {
  const { data: environment } = useEnvironment()
  const rows: OrganizationAffiliation[] = organizationAffiliations?.data ?? []

  return (
    <>
      <h3>OrganizationAffiliation</h3>

      {isFetching ? (
        <FhirLoader message="Loading..." />
      ) : (
        <>
          {organizationAffiliations?.total > 0 && environment?.includeTotalInFHIRRequest && (
            <div className="my-3 fw-bold">
              <span role="status" aria-live="polite">
                {organizationAffiliations.total.toLocaleString()} record(s) found
              </span>
              <PaginationButtons
                totalPages={totalPages}
                currentPage={currentPage}
                handleChangePage={handleChangePage}
              />
            </div>
          )}

          <OrganizationAffiliationTable
            organizationAffiliations={rows}
            onRowLinkClick={clickViewDataLink}
          />

          {organizationAffiliations?.total > 0 && environment?.includeTotalInFHIRRequest && (
            <div className="my-3 fw-bold">
              <PaginationButtons
                totalPages={totalPages}
                currentPage={currentPage}
                handleChangePage={handleChangePage}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}

export default OrganizationAffiliationList
